// extracted by mini-css-extract-plugin
export default {"custom-progress-bar":"style_custom-progress-bar__Z9Iz8","custom-progress-bar__text":"style_custom-progress-bar__text__TWLWT"};